const descriptionTransitionDurationMs = 200;
const wrapper = "_vcw1dmes37";
const description = "_vcdnjxvfv";
const descriptionTogglerWrapper = "_vcd58zjh6";
const descriptionToggler = "_vcd1eimfjv";

export { description, descriptionToggler, descriptionTogglerWrapper, descriptionTransitionDurationMs, wrapper };
import "./atom.description.style.linaria.module.css";
//# sourceMappingURL=atom.description.style.js.map
